
export const setupObserver = (selector, activeSelector, activeClass) => {

    selector = (selector || '').trim();
    activeSelector = (activeSelector || '').trim();
    activeClass = (activeClass || '').trim();

    if (selector.length === 0 || activeSelector.length === 0 || activeClass.length === 0) {
        return;
    }

    setTimeout(() => {
        const cards = document.querySelectorAll(selector);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    document.querySelector(activeSelector)?.classList.remove(activeClass);
                    entry.target.classList.add(activeClass);
                }
            });
        }, {
            root: null,
            threshold: 0,
            rootMargin: "-45% 0px -45% 0px"
        });


        cards.forEach(card => observer.observe(card));
    }, 1000)


}


